import { useAppSelector } from '@/hooks/useAppSelector';

import { authUser } from '../services/selectors/auth';

export const useIsAdmin = () => Boolean(useAppSelector(authUser)?.isAdmin);
